import React, { createContext, useContext, useState } from "react"

const ClientQueryContext = createContext(null);


export const useClientQueryContext = () => {
    const context = useContext(ClientQueryContext)
    return context; 
}

export const ClientQueryContextProvider = ({ children }) => {
    const [reloadClientQueries,setReloadClientQueries] = useState(false); 
    return (
        <ClientQueryContext.Provider value={{ reloadClientQueries,setReloadClientQueries }}>
            {children}
        </ClientQueryContext.Provider>
    )
}